import React from "react"
import DocIcon from "../../../../../assets/images/doc-icon.svg"
import { Link } from "gatsby"
import BmiFeaturesSectionStyle from "../../../../bmiCalculator/components/shared/bmiFeaturesSection/BmiFeaturesSectionStyle.module.styl"
import translate from "../../../../../translation/translator"
import keys from "../../../../../translation/keys"

const NutritionFeaturesSection = ({ locale }) => {
  return (
    <div className={BmiFeaturesSectionStyle.holder}>
      <h2 className={BmiFeaturesSectionStyle.section_title}>
        {translate(keys.NUTRITION_FEATURES_RESORS, locale)}{" "}
        <span>{translate(keys.NUTRITION_FEATURES_AMOUNT, locale)}</span>
      </h2>
      <div className="row">
        <div className="col-lg-3 col-sm-6">
          <div className={BmiFeaturesSectionStyle.feature}>
            <img
              className={BmiFeaturesSectionStyle.icon}
              src={DocIcon}
              alt="doc-icon"
            />
            <Link
              to={translate(keys.NUTRITION_URI_I, locale)}
              className={BmiFeaturesSectionStyle.title}
            >
              {translate(keys.NUTRITION_FEATURES_HOW_TO, locale)}
            </Link>
            <p>{translate(keys.NUTRITION_FEATURES_WHAT_INFO, locale)}</p>
            <Link to={translate(keys.NUTRITION_URI_I, locale)}>
              {translate(keys.NUTRITION_FEATURES_READ_MORE, locale)}
            </Link>
          </div>
        </div>
        <div className="col-lg-3 col-sm-6">
          {" "}
          <div className={BmiFeaturesSectionStyle.feature}>
            <img
              className={BmiFeaturesSectionStyle.icon}
              src={DocIcon}
              alt="doc-icon"
            />
            <Link
              to={translate(keys.NUTRITION_URI_II, locale)}
              className={BmiFeaturesSectionStyle.title}
            >
              {translate(keys.NUTRITION_FEATURES_MACROS, locale)}
            </Link>
            <p>{translate(keys.NUTRITION_FEATURES_IMPORTANT_FOOD, locale)}</p>
            <Link to={translate(keys.NUTRITION_URI_II, locale)}>
              {translate(keys.NUTRITION_FEATURES_READ_MORE, locale)}
            </Link>
          </div>
        </div>
        <div className="col-lg-3 col-sm-6">
          {" "}
          <div className={BmiFeaturesSectionStyle.feature}>
            <img
              className={BmiFeaturesSectionStyle.icon}
              src={DocIcon}
              alt="doc-icon"
            />
            <Link
              to={translate(keys.NUTRITION_URI_III, locale)}
              className={BmiFeaturesSectionStyle.title}
            >
              {translate(keys.NUTRITION_FEATURES_RECOMENDS, locale)}
            </Link>
            <p>{translate(keys.NUTRITION_FEATURES_COMMON_FOODS, locale)}</p>
            <Link to={translate(keys.NUTRITION_URI_III, locale)}>
              {translate(keys.NUTRITION_FEATURES_READ_MORE, locale)}
            </Link>
          </div>
        </div>
        <div className="col-lg-3 col-sm-6">
          {" "}
          <div className={BmiFeaturesSectionStyle.feature}>
            <img
              className={BmiFeaturesSectionStyle.icon}
              src={DocIcon}
              alt="doc-icon"
            />
            <Link
              to={translate(keys.NUTRITION_URI_IV, locale)}
              className={BmiFeaturesSectionStyle.title}
            >
              {translate(keys.NUTRITION_FEATURES_RECOMEND_COMBOS, locale)}
            </Link>
            <p>
              {translate(keys.NUTRITION_FEATURES_RECOMEND_COMBOS_TIPS, locale)}
            </p>
            <Link to={translate(keys.NUTRITION_URI_IV, locale)}>
              {translate(keys.NUTRITION_FEATURES_READ_MORE, locale)}
            </Link>
          </div>
        </div>
      </div>
    </div>
  )
}

export default NutritionFeaturesSection
